import styled from 'styled-components'

const Page = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: auto minmax(auto, 750px) auto;
  grid-template-areas:
    '. header .'
    '. content .'
    '. footer .';
  grid-template-rows: 1fr 1fr 1fr;
  overflow-y: auto;
`

const Header = styled.div`
  grid-area: header;
  place-self: center;
  padding: 30px 0;

  img {
    max-width: 300px;
  }
`

const Content = styled.div`
  grid-area: content;
  padding: 0 30px;
`

const Footer = styled.div`
  grid-area: footer;
  display: inline-flex;
  justify-content: center;
`

const Heading = styled.h2`
  margin-top: 0;
  margin-bottom: 30px;
`

const Paragraph = styled.p`
  font-size: 16px;
`

const UnauthenticatedLanding = () => {
  return (
    <Page>
      <Header>
        <img
          src="/assets/img/road-sign.svg"
          alt="A person with two roads ahead of them pointing different ways"
        />
      </Header>
      <Content>
        <Heading>Hey...</Heading>
        <Paragraph>Looks like you took a wrong turning.</Paragraph>
        <Paragraph>
          If you're looking to submit your referencing, just go to your most recent
          Referencing email from Goodlord to find a link or any further support you may be
          looking for.
        </Paragraph>
      </Content>
      <Footer />
    </Page>
  )
}

export default UnauthenticatedLanding
